import iconBundle from "./icon.bundle.js";
export default {
    name: "Icon",
    data() {
        return {
            iconValue: "",
        };
    },
    props: {
        name: {
            type: String,
            defaultValue: "",
        },
    },
    methods: {
        setIconTemplate() {
            if (this.name && iconBundle[this.name]) {
                this.iconValue = iconBundle[this.name];
            }
        },
    },

    mounted() {
        this.setIconTemplate();
    },
    watch: {
        name() {
            this.setIconTemplate();
        },
    },
};
